import axios from "helpers/_axios";
import hasProperty from "lodash/has";
export const LOADING_ROLE = "LOADING_ROLE";
export const ERROR_ROLE = "ERROR_ROLE";
export const GET_ALL_ROLES = "GET_ALL_ROLES";
export const GET_PERMISSIONS = "GET_PERMISSIONS";
export const GET_ROLE = "GET_ROLE";
export const ADD_ROLE = "ADD_ROLE";
export const UPDATE_ROLE = "UPDATE_ROLE";
export const DELETE_ROLE = "DELETE_ROLE";

export const getAllRoles = ({
  name = "",
  type = "",
  page = 1
}) => async dispatch => {
  try {
    dispatch({
      type: LOADING_ROLE,
      payload: true
    });
    const result = await axios().get(
      `/roles?page=${page}&name=${name}&type=${type}`
    );
    dispatch({
      type: LOADING_ROLE,
      payload: false
    });
    return dispatch({
      type: GET_ALL_ROLES,
      payload: result.data
    });
  } catch (error) {
    dispatch({
      type: LOADING_ROLE,
      payload: false
    });
    dispatch({
      type: GET_ALL_ROLES,
      payload: hasProperty(error, "response.status") ? error.response.status : 0
    });
    dispatch({
      type: ERROR_ROLE,
      payload: error
    });
  }
};

export const getPermissions = () => async dispatch => {
  try {
    const result = await axios().get(`/roles/permissions`);
    return dispatch({
      type: GET_PERMISSIONS,
      payload: result.data.data
    });
  } catch (error) {
    dispatch({
      type: GET_PERMISSIONS,
      payload: hasProperty(error, "response.status") ? error.response.status : 0
    });
  }
};

export const getRole = id => async dispatch => {
  try {
    dispatch({
      type: LOADING_ROLE,
      payload: true
    });
    const result = await axios().get(`/roles/${id}`);
    dispatch({
      type: LOADING_ROLE,
      payload: false
    });
    dispatch({
      type: ERROR_ROLE,
      payload: null
    });
    dispatch({
      type: GET_ROLE,
      payload: result.data
    });
  } catch (error) {
    dispatch({
      type: LOADING_ROLE,
      payload: false
    });
    dispatch({
      type: GET_ROLE,
      payload: hasProperty(error, "response.status") ? error.response.status : 0
    });
    dispatch({
      type: ERROR_ROLE,
      payload: error
    });
  }
};

export const addRole = data => async dispatch => {
  try {
    dispatch({
      type: LOADING_ROLE,
      payload: true
    });
    const result = await axios().post(`/roles`, data);
    dispatch({
      type: ERROR_ROLE,
      payload: null
    });
    dispatch({
      type: ADD_ROLE,
      payload: result.data.data
    });
    dispatch({
      type: LOADING_ROLE,
      payload: false
    });
  } catch (error) {
    dispatch({
      type: LOADING_ROLE,
      payload: false
    });
    dispatch({
      type: ERROR_ROLE,
      payload: error
    });
  }
};

export const updateRole = ({ id, data }) => async dispatch => {
  try {
    dispatch({
      type: LOADING_ROLE,
      payload: true
    });
    const result = await axios().put(`/roles/${id}`, data);
    dispatch({
      type: LOADING_ROLE,
      payload: false
    });
    dispatch({
      type: ERROR_ROLE,
      payload: null
    });
    dispatch({
      type: UPDATE_ROLE,
      payload: result.data.data
    });
  } catch (error) {
    dispatch({
      type: LOADING_ROLE,
      payload: false
    });
    dispatch({
      type: ERROR_ROLE,
      payload: error
    });
  }
};

export const deleteRole = id => async dispatch => {
  try {
    dispatch({
      type: LOADING_ROLE,
      payload: true
    });
    const result = await axios().delete(`/roles/${id}`);
    dispatch({
      type: LOADING_ROLE,
      payload: false
    });
    dispatch({
      type: ERROR_ROLE,
      payload: null
    });
    dispatch({
      type: DELETE_ROLE,
      payload: result.status
    });
  } catch (error) {
    dispatch({
      type: DELETE_ROLE,
      payload: hasProperty(error, "response.status") ? error.response.status : 0
    });
    dispatch({
      type: LOADING_ROLE,
      payload: false
    });
    dispatch({
      type: ERROR_ROLE,
      payload: error
    });
  }
};

export const resetPayload = type => dispatch => {
  dispatch({
    type: type,
    payload: null
  });
};
